import React from 'react'
import styled from 'styled-components'

import { KeyboardShortcutKeyAnnotation } from 'components/KeyboardShortcutKeyAnnotation'

export type ShortcutTooltipProps = {
  label: string
  /** Display-formatted shortcut, e.g. from `useShortcutDisplay`. */
  shortcut: string
}

/** Tooltip body pairing a label with its keyboard-shortcut key badge. */
export const ShortcutTooltip: React.FC<ShortcutTooltipProps> = ({
  label,
  shortcut,
}) => (
  <Row>
    {label}
    <Badge shortcut={shortcut} />
  </Row>
)

const Row = styled.span`
  display: flex;
  align-items: center;
`

const Badge = styled(KeyboardShortcutKeyAnnotation)`
  margin-left: 8px;
`
